import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';

export default function ForgotPasswordPage() {
  const [username, setUsername] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await authAPI.forgotPassword(username);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-slate-100 min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-slate-200">
        <div className="mb-4">
          <Link to="/login" className="text-xs font-semibold text-slate-500 hover:text-emerald-600 inline-flex items-center gap-1 transition-colors">
            &larr; Back to Login
          </Link>
        </div>
        <div className="text-center mb-6">
          <img
            src="/logo192.png"
            alt="Irie Roots Logo"
            className="w-14 h-14 rounded-2xl object-cover mx-auto mb-2.5 shadow-md shadow-emerald-500/20 border border-slate-100"
          />
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Reset Password</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Staff Sign In Recovery</p>
        </div>

        {sent ? (
          <div className="text-center text-sm text-gray-700 dark:text-gray-300">
            <p>If that account exists, a password reset link has been sent to its email.</p>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">The link works once and expires in an hour.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
                <span className="block sm:inline">{error}</span>
              </div>
            )}
            <div className="mb-6">
              <label className="block text-gray-700 dark:text-gray-300 mb-2" htmlFor="username">
                Username
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-60"
            >
              {submitting ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
